<template>
  <transition-group tag="div" name="efade" appear id="toolbar">
    <tool v-if="archive" @click="$router.push({ name: 'archive' })" title="Archive" key="archive" class="left">
      <template>
        <icon name="Archive" class="icon"/>
      </template>
    </tool>

    <tool key="backTool" v-if="back" title="Back" class="left" @click="$bus.$emit('back')">
      <template>
        <icon name="Arrow" class="icon"/>
      </template>
    </tool>

    <tool
        v-if="scroll || mobileScrollWatch"
        @click="
        () => {
          $bus.$emit('scrollDown');
          $bus.$emit('scrollPDown');
        }
      "
        key="scrollTool"
        title="Scroll Down"
        class="center"
    >
      <template>
        <icon name="Arrow" class="icon transform -rotate-90"/>
      </template>
    </tool>

    <scale-tool
        v-if="scale"
        key="scaleTool"
        :class="{
        'tool right large': true,
        hidden: $store.state.screenSize === 1,
      }"
    />

    <nav-tool v-if="nav" key="navTool" class="tool right"></nav-tool>

    <tool v-if="skip" key="skipTool" class="tool right" title="Skip Intro" @click="$router.push({ name: 'education' })">
      <template>
        <icon name="SkipIntro" class="icon"/>
      </template>
    </tool>
  </transition-group>
</template>

<script>
import Tool from '@components/tools/Tool';
import ScaleTool from '@components/tools/ScaleTool';
import NavTool from '@components/tools/NavTool';

export default {
  name: 'Toolbar',
  components: {
    ScaleTool,
    Tool,
    NavTool,
  },
  data() {
    return {
      scrollEnd: false,
      hideSkip: false
    };
  },
  computed: {
    home() {
      return this.$route.name === 'home';
    },
    back() {
      return !this.home && !(this.$route.meta.index > 0);
    },
    scale() {
      return (this.$route.meta.index >= 1 && this.$route.name !== '404') || this.$route.name === 'archive';
    },
    scroll() {
      return !this.scrollEnd && !['404', 'team-detail', 'news-detail'].includes(this.$route.name);
    },
    mobileScrollWatch() {
      return !this.scrollEnd && ['team-detail', 'news-detail'].includes(this.$route.name) && this.$store.state.screenSize === 1;
    },
    archive() {
      return this.$route.name === 'education';
    },
    skip() {
      return this.hideSkip === false && this.$route.name === 'home' && this.$store.state.screenSize === 1;
    },
    nav() {
      return !this.home && `${this.$route.name ?? ''}`.includes('detail');
    },
  },
  mounted() {
    this.$bus.$on('scroll-end', end => (this.scrollEnd = end));
    this.$bus.$on('hide-skip', () => {
      console.log('skip hide');
      this.hideSkip = true
    });
  },
  watch: {
    $route(to, from) {
      this.scrollEnd = false;
    },
  },
};
</script>

<style lang="scss">
#toolbar {
  position: absolute;
  bottom: 0;
  left: 2rem;
  right: 2rem;
  height: 60px;

  @media screen and (max-width: 600px) {
    left: 1rem !important;
    right: 1rem !important;
  }

  .tool {
    position: absolute;
    cursor: pointer;
    top: 50%;
    transform: translateY(-50%);

    &.left {
      left: 0;
    }

    &.right {
      right: 0;
    }

    &.center {
      left: 50%;
      transform: translate(-50%, -50%);
    }

    &.large {
      width: 25%;
    }

    span {
      @apply mb-1;
    }
  }

  .svg-use {
    fill: white;
  }

  .navt {
    &:hover {
      > span {
        @apply text-dm;
      }

      path {
        fill: rgb(240, 40, 75) !important;
      }
    }
  }

  .tool:not(.navtool) {
    &:hover {
        > span {
          @apply text-dm;
        }

        path {
          fill: rgb(240, 40, 75) !important;
        }
    }
  }
}
</style>
